import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csoverride(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Override Learn Free tutorial For Beginners</title>
 <meta name="description" content="C# override tutorial for beginners.Method overriding in C# is the example of Run time polymorphism and this is also known as a dynamic polymorphism.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# override,c# override for,c sharp override," />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-overriding" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Override in C#</h1>
    <div className="first">
        <a href="/csharp-overloading">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">What is an override in C#</h2>
    <p className="mt-4 para">Method overriding in C# is the example of Run time polymorphism and this is also known as a <span className="bold"> dynamic polymorphism.</span>
</p>

<h2 className="mt-4 mh2">Rules of method overriding in C#:
</h2>
<h3 className="mt-4 mh3">1, If you call two overrides in CSharp(C#) method  so both methods place inside different classes<br/>
2, Two or multiple method names are same<br/>
3, Two or multiple method  argument are same <br/>
</h3>
<h4 className="mt-4">A, A sequence of argument<br/>
B, Numbers of argument<br/>
C, Type of argument<br/>
</h4>
<h3 className="mt-4 mh3">4, Inheritance(IS-A) relationship
</h3>



<h2 className="headings">Q-No of argument example in C# override Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-7">override1</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-5">1 </span>
            <span className="qwerty-6">over</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">class </span>
            <span className="qwerty-7">override2 </span>
            <span className="qwerty-4">extends </span>
            <span className="qwerty-7">override1</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-4">2</span>
            <span className="qwerty-6"> over</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">public </span>
            <span className="qwerty-7">static </span>
            <span className="qwerty-5">void</span>
            <span className="qwerty-4"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-3"> args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">override1</span>
            <span className="qwerty-3"> o</span>
            <span className="qwerty-1"> =  </span>
            <span className="qwerty-3">new </span>
            <span className="qwerty-7">override1 </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">o.over </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-1">1 </span>
            <span className="qwerty-5">over </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className="headings">Q-Write a Program to check which Object call example in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-7">override1</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-5">1 </span>
            <span className="qwerty-6">over</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">class </span>
            <span className="qwerty-7">override2 </span>
            <span className="qwerty-4">extends </span>
            <span className="qwerty-7">override1</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-4">2</span>
            <span className="qwerty-6"> over</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">public </span>
            <span className="qwerty-7">static </span>
            <span className="qwerty-5">void</span>
            <span className="qwerty-4"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-3"> args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">override2</span>
            <span className="qwerty-3"> o</span>
            <span className="qwerty-1"> =  </span>
            <span className="qwerty-3">new </span>
            <span className="qwerty-7">override2 </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">o.over </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-1">2 </span>
            <span className="qwerty-5">over </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className="headings">Q-A type of argument in C# override Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-7">override1</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-5">1 </span>
            <span className="qwerty-6">over</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">class </span>
            <span className="qwerty-7">override2 </span>
            <span className="qwerty-4">extends </span>
            <span className="qwerty-7">override1</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-4">2</span>
            <span className="qwerty-6"> over</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">public </span>
            <span className="qwerty-7">static </span>
            <span className="qwerty-5">void</span>
            <span className="qwerty-4"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-3"> args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">override2</span>
            <span className="qwerty-3"> o</span>
            <span className="qwerty-1"> =  </span>
            <span className="qwerty-3">new </span>
            <span className="qwerty-7">override2 </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">o.over </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-1">2 </span>
            <span className="qwerty-5">over </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-A type of argument Example in C# override Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-7">override1</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">int</span>
            <span className="qwerty-6"> a</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-5">1 </span>
            <span className="qwerty-6">over</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">class </span>
            <span className="qwerty-7">override2 </span>
            <span className="qwerty-4">extends </span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">int</span>
            <span className="qwerty-6"> a</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-5">2</span>
            <span className="qwerty-6"> over</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">public </span>
            <span className="qwerty-7">static </span>
            <span className="qwerty-5">void</span>
            <span className="qwerty-4"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-3"> args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">override1</span>
            <span className="qwerty-3"> o</span>
            <span className="qwerty-1"> =  </span>
            <span className="qwerty-3">new </span>
            <span className="qwerty-7">override1 </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">o.over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">50</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-1">1 </span>
            <span className="qwerty-5">over </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-The sequence of argument in C# override Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-7">override1</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">int</span>
            <span className="qwerty-6"> x</span>
            <span className="qwerty-1">,</span>
            <span className="qwerty-6"> String </span>
            <span className="qwerty-7">y</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-7">override</span>
            <span className="qwerty-6"> int</span>
            <span className="qwerty-6"> string</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">class </span>
            <span className="qwerty-7">override2 </span>
            <span className="qwerty-4">extends </span>
            <span className="qwerty-7">override1 </span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">int</span>
            <span className="qwerty-6"> x</span>
            <span className="qwerty-1">,</span>
            <span className="qwerty-6"> String </span>
            <span className="qwerty-7">y</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-7">override</span>
            <span className="qwerty-6"> string</span>
            <span className="qwerty-4"> int</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">public </span>
            <span className="qwerty-7">static </span>
            <span className="qwerty-5">void</span>
            <span className="qwerty-4"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-3"> args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">override1</span>
            <span className="qwerty-3"> o</span>
            <span className="qwerty-1"> =  </span>
            <span className="qwerty-3">new </span>
            <span className="qwerty-7">override1 </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">o.over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">50</span>
            <span className="qwerty-1">, </span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">Ram</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-1">override </span>
            <span className="qwerty-4">int </span>
            <span className="qwerty-5">String </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="headings">Q-Sequence of argument in C# override Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-7">override1</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">int</span>
            <span className="qwerty-6"> x</span>
            <span className="qwerty-1">,</span>
            <span className="qwerty-6"> String </span>
            <span className="qwerty-7">y</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-7">override</span>
            <span className="qwerty-6"> int</span>
            <span className="qwerty-6"> string</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">class </span>
            <span className="qwerty-7">override2 </span>
            <span className="qwerty-4">extends </span>
            <span className="qwerty-7">override1 </span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-6">over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">int</span>
            <span className="qwerty-6"> x</span>
            <span className="qwerty-1">,</span>
            <span className="qwerty-6"> String </span>
            <span className="qwerty-7">y</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-7">override</span>
            <span className="qwerty-6"> string</span>
            <span className="qwerty-4"> int</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-4">public </span>
            <span className="qwerty-7">static </span>
            <span className="qwerty-5">void</span>
            <span className="qwerty-4"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-3"> args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">override2</span>
            <span className="qwerty-3"> o</span>
            <span className="qwerty-1"> =  </span>
            <span className="qwerty-3">new </span>
            <span className="qwerty-7">override2 </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">o.over </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">40</span>
            <span className="qwerty-1">, </span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">Lakshmana</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-1">override </span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-4">int </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-overloading">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csoverride;